export default __webpack_public_path__ + "roboto-v27-latin-700italic.b704d4.svg";